import * as yup from 'yup';

export const schema = yup
    .object({
        amount_to_pay: yup
            .number()
            .required('Это поле необходимо заполнить')
            .min(1, 'Сумма должна быть больше нуля')
    })
    .required();

export interface PaymentForm {
    amount_to_pay: number;
}